import { Stack } from '@mui/material';
import { ReactNode } from 'react';

export const BottomNavigation = ({
  children,
  bgColor,
}: {
  bgColor?: string;
  children: ReactNode;
}) => {
  return (
    <Stack
      display="flex"
      direction="row"
      spacing={1}
      alignItems="center"
      justifyContent="space-between"
      boxShadow="0px -4px 19px 10px rgba(0,0,0,0.15)"
      sx={{
        borderTop: theme => `1px solid ${theme.palette.text.disabled}`,
        bgcolor: bgColor,
        paddingX: '10px',
        paddingY: '12px',
        height: '8vh',
        position: 'sticky',
        bottom: 'env(safe-area-inset-bottom)',
      }}
    >
      {children}
    </Stack>
  );
};
